module.exports = __webpack_public_path__ + "static/media/apple-circle.2ae2994d.svg";